export const INBOX_TREATMENT_GET_INFERENCE_EVENT = 'INBOX_TREATMENT_LIST_INFERENCE_EVENT';
export const INBOX_TREATMENT_GET_INFERENCE_EVENT_SUCCESS = 'INBOX_TREATMENT_GET_INFERENCE_EVENT_SUCCESS';
export const INBOX_TREATMENT_GET_INFERENCE_EVENT_FAIL = 'INBOX_TREATMENT_GET_INFERENCE_EVENT_FAIL';

export const INBOX_TREATMENT_GET_INFERENCE_EVENT_CLEAR = 'INBOX_TREATMENT_GET_INFERENCE_EVENT_CLEAR';
